import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { PlayerListComponent } from './player-list/player-list.component';
import { PlayerDetailComponent } from './player-detail/player-detail.component';
import { AllianceListComponent } from './alliance-list/alliance-list.component';
import { AllianceDetailComponent } from './alliance-detail/alliance-detail.component';
import { ScanListComponent } from './scan-list/scan-list.component';
import { ScanDetailComponent } from './scan-detail/scan-detail.component';
import { StellarCartographyComponent } from './stellar-cartography/stellar-cartography.component';
import { ChangelogComponent } from './changelog/changelog.component';
import { StarmapComponent } from './stellar-cartography/components/starmap/starmap.component';
import { SectorHeaderComponent } from './stellar-cartography/components/sector-header/sector-header.component';
import { SectorDetailsComponent } from './stellar-cartography/components/sector-details/sector-details.component';
import { OverviewComponent } from './admin/overview/overview.component';
import { UserListComponent } from './admin/user-list/user-list.component';
import { UserCreateComponent } from './admin/user-create/user-create.component';
import { UserDetailComponent } from './admin/user-detail/user-detail.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ComponentsModule } from '../components/components.module';
import { AppRoutingModule } from '../app-routing.module';
import { PipesModule } from '../pipes/pipes.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    HomeComponent,
    PlayerListComponent,
    PlayerDetailComponent,
    AllianceListComponent,
    AllianceDetailComponent,
    ScanListComponent,
    ScanDetailComponent,
    StellarCartographyComponent,
    ChangelogComponent,
    StarmapComponent,
    SectorHeaderComponent,
    SectorDetailsComponent,
    OverviewComponent,
    UserListComponent,
    UserCreateComponent,
    UserDetailComponent,
    UnauthorizedComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    AppRoutingModule,
    PipesModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ViewsModule {}
